import { useAllMovements, enumsCashback, formatDate } from '@itarget/shared'
import { useContext } from 'react'
import { FidelityContext } from '../../../context/FidelityContext'

const filterCreditTransactions = ({ transactionType }) => transactionType === enumsCashback.OPERATIONS.TRANSACTION_TYPE.CREDIT
const filterDebitTransactions = ({ transactionType }) => transactionType === enumsCashback.OPERATIONS.TRANSACTION_TYPE.DEBIT
const filterToReceiveTransactions = ({ transactionDate, redemptionStartAt }) => {
  transactionDate = new Date(transactionDate.split(' ').join('T'))
  const today = new Date()
  const daysDifference = formatDate.dateDifferenceInDays(transactionDate, today)
  return daysDifference < redemptionStartAt
}
const filterExpiredTransactions = ({ transactionDate, redemptionEndAt }) => {
  transactionDate = new Date(transactionDate.split(' ').join('T'))
  const today = new Date()
  const daysDifference = formatDate.dateDifferenceInDays(transactionDate, today)
  return daysDifference > redemptionEndAt && redemptionEndAt !== 0
}

const filterTransactions = (transactions, filterStatementsEnums, currentFilter) => {
  let cloneTransactions = Array.from(transactions)

  if (filterStatementsEnums.accumulation === currentFilter) {
    cloneTransactions = cloneTransactions.filter(filterCreditTransactions)
  }

  if (filterStatementsEnums.redemption === currentFilter) {
    cloneTransactions = cloneTransactions.filter(filterDebitTransactions)
  }

  if (filterStatementsEnums.expired === currentFilter) {
    cloneTransactions = cloneTransactions.filter(filterExpiredTransactions)
  }

  if (filterStatementsEnums.toReceive === currentFilter) {
    cloneTransactions = cloneTransactions.filter(filterToReceiveTransactions)
  }

  return cloneTransactions
}

const groupTransactionsBy = (transactions, groupBy = {}) => {
  let cloneTransactions = Array.from(transactions)

  if (Object.hasOwn(groupBy, 'transactionDate')) {
    if (groupBy.transactionDate) {
      cloneTransactions = Object.groupBy(cloneTransactions, ({ transactionDate }) => transactionDate.split(' ')[0])
    }
  }

  return cloneTransactions
}

const getDateTransactionsBalance = (transactions) => {
  let balance = 0
  for (const { points, transactionType } of transactions) {
    if (transactionType === 'D') {
      balance -= Number(points)
      continue
    }
    balance += Number(points)
  }
  return balance
}

export const useGroup = () => {
  const { getAllMovements, isAllMovementsLoaded } = useAllMovements()
  const { filterStatementsEnums, getCurrentStatementFilter } = useContext(FidelityContext)

  let groupCollection = filterTransactions(getAllMovements(), filterStatementsEnums, getCurrentStatementFilter())
  groupCollection = groupTransactionsBy(groupCollection, { transactionDate: true })

  groupCollection = Object.entries(groupCollection).map(([date, transactions]) => {
    const newCollection = {}
    Object.defineProperty(newCollection, 'date', { value: date })
    Object.defineProperty(newCollection, 'balance', { value: getDateTransactionsBalance(transactions) })
    Object.defineProperty(newCollection, 'transactions', { value: transactions })

    return newCollection
  })

  return { groupCollection, isAllMovementsLoaded }
}
